import SectionTitle from 'components/SectionTitle';

const ConnectorTitle = ({ connectorName }: { connectorName: string | null | undefined }) => {
  return (
    <SectionTitle
      title={
        <span>
          Conector
          <span data-testid="connector-drawer-title">{` ${connectorName}`}</span>
        </span>
      }
    />
  );
};

export default ConnectorTitle;
